import { render, staticRenderFns } from "./plattask copy.vue?vue&type=template&id=4a3db8a2&"
import script from "./plattask copy.vue?vue&type=script&lang=js&"
export * from "./plattask copy.vue?vue&type=script&lang=js&"
import style0 from "./plattask copy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports